import { createFileRoute, redirect } from "@tanstack/react-router";
import { completeProductCheckout } from "api-client";
import { z } from "zod";

import { getProductErrorMessage } from "src/helpers/productErrorMessage";
import { loaderHandler } from "src/lib/loaderHandler";
import { PublicProductSuccessPage } from "src/pages/PublicProductSuccessPage";

const routeSearchSchema = z.object({
  session_id: z.string(),
  productId: z.string(),
});

export const Route = createFileRoute("/c/$slug_/p/$productSlug_/success")({
  component: RoutePage,
  ssr: true,
  validateSearch: routeSearchSchema,
  loaderDeps: (args) => {
    return {
      sessionId: args.search.session_id,
      productId: args.search.productId,
    };
  },
  async loader(args) {
    return await loaderHandler(async ({ i18n }) => {
      const response = await completeProductCheckout({
        path: { productId: args.deps.productId },
        body: { sessionId: args.deps.sessionId },
        throwOnError: false,
      });

      if (response.error) {
        return {
          data: { message: getProductErrorMessage(i18n.t, response.error) },
        };
      }

      const status = response.data.data.status;

      if (status === "COMPLETED") {
        throw redirect({ to: "/", search: { installMobileApp: true } });
      }

      if (status === "PENDING") {
        return {
          data: { message: i18n.t("publicProduct.success.pending") },
        };
      }

      return {
        data: { message: i18n.t("publicProduct.success.notCompleted") },
      };
    });
  },
  head() {
    return { meta: [{ name: "robots", content: "noindex" }] };
  },
  staticData: {
    getLayoutSettings() {
      return {
        showAuthSidebar: false,
        useAuthLayout: false,
      };
    },
  },
});

function RoutePage() {
  const loaderData = Route.useLoaderData();
  const params = Route.useParams();

  return (
    <PublicProductSuccessPage
      message={loaderData.data.message}
      coachSlug={params.slug}
      productSlug={params.productSlug}
    />
  );
}
